module.exports = __webpack_public_path__ + "assets/img/1-3.46fe1c59.png";